//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Tracks the attendance status of the individual. */
export const AttendanceStatus = {
    /** The individual did not attend and is not present in the room. */
    DidNotAttend: 0,

    /** The individual did attend but may not be present in the room. */
    DidAttend: 1,

    /** The individual did attend and is currently present in the room. */
    IsPresent: 2
} as const;

/** Tracks the attendance status of the individual. */
export const AttendanceStatusDescription: Record<number, string> = {
    0: "Did Not Attend",

    1: "Did Attend",

    2: "Is Present"
};

/** Tracks the attendance status of the individual. */
export type AttendanceStatus = typeof AttendanceStatus[keyof typeof AttendanceStatus];
